export default __webpack_public_path__ + "palais.fa13dee.jpg";